import { render } from "./ResonanceDetailPage.vue?vue&type=template&id=e83b95d2&scoped=true"
import script from "./ResonanceDetailPage.vue?vue&type=script&lang=js"
export * from "./ResonanceDetailPage.vue?vue&type=script&lang=js"

import "./ResonanceDetailPage.vue?vue&type=style&index=0&id=e83b95d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83b95d2"]])

export default __exports__